export default "__VITE_ASSET__CgdLgfMY__"